import { DialogContent, DialogTitle, Typography } from '@mui/material';
import { PrescriptionDialogStyle } from 'Components';
import { useDictionary, useIsDesktop } from 'Hooks';
import { ContactUsMobile } from 'Components/ContactUsMobile';
import { EquipmentList } from './EquipmentList';
import { EquipmentOrderStatus } from './EquipmentOrderStatus';
import { DialogTitleContent } from '../DialogTitleContent';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { IEquipmentPrevOrder } from 'API';

interface IOrderStatusDialogProps {
  onClose: () => void;
  open: boolean;
  item: IEquipmentPrevOrder;
}

export const OrderStatusDialog = ({
  onClose,
  open,
  item,
}: IOrderStatusDialogProps) => {
  const isDesktop = useIsDesktop();
  const orderItems = item.orderItems;
  const dictionary = useDictionary(Dictionary, DICTIONARY.Equipment);

  const medicationsDictionary = useDictionary(
    Dictionary,
    DICTIONARY.MedicationsAndPrescriptionsLobby
  );

  const dialogTitleStyle = {
    padding: '0',
    background: '#39546A',
    paddingRight: '40px',
    paddingLeft: '40px',
    height: '92px',
  };

  const dialogTitleStyleMobile = {
    padding: '35px 24px 16px 24px',
    background: '#FFF',
    height: '135px',
  };

  const dialogContentStyle = {
    padding: isDesktop ? '32px 64px 56px !important' : '0 24px',
    backgroundColor: '#FFF',
  };

  return (
    <PrescriptionDialogStyle
      open={open}
      onClose={onClose}
      labelledby='order-status-dialog-title'
      describedby='order-status-dialog-content'
    >
      <DialogTitle
        sx={isDesktop ? dialogTitleStyle : dialogTitleStyleMobile}
        id='order-status-dialog-title'
      >
        <DialogTitleContent
          onClose={onClose}
          requestNumber={item.requestNumber}
        />
      </DialogTitle>
      <DialogContent sx={dialogContentStyle} id='order-status-dialog-content'>
        <EquipmentOrderStatus order={item} />
        <EquipmentList orderItems={orderItems} />

        {item.note && (
          <>
            <Typography
              sx={{
                margin: '70px 0 15px 0',
                fontSize: '18px',
                fontWeight: 'bold',
              }}
            >
              {dictionary.createOrder.orderNote}
            </Typography>
            <Typography>{item.note}</Typography>
          </>
        )}
        {!isDesktop && (
          <ContactUsMobile
            title={
              item.currentStatus !== 4 //4 is superpharm process status
                ? medicationsDictionary.haveQuestionsOnPrescriptions
                : medicationsDictionary.haveQuestionsAboutSupply
            }
            description={
              item.currentStatus !== 4
                ? medicationsDictionary.willBeHappyToHelp
                : medicationsDictionary.superPharmForYourSupport
            }
            phoneNumber={
              item.currentStatus !== 4
                ? medicationsDictionary.manualSupplyPhone
                : medicationsDictionary.superPharmPhone
            }
            phoneNumberTel={
              item.currentStatus !== 4
                ? medicationsDictionary.manualSupplyPhoneTel
                : medicationsDictionary.superPharmPhone
            }
          />
        )}
      </DialogContent>
    </PrescriptionDialogStyle>
  );
};
